module.exports = __webpack_public_path__ + "img/1426dd5.jpg";